import * as React from 'react';
import { useContext, useMemo } from 'react';
import { Option, GroupedOption } from '../types/Options';
import { SearchContext } from '../../SearchContext';
import { entries } from '../../../helpers';

interface PickerItemProps {
    id: string;
    option: Option | GroupedOption;
    selected: string[];
    child?: boolean;
    parentId?: string;
    onClick: (key: string) => any;
}

export const PickerItem: React.FC<PickerItemProps> = ({
    id,
    option,
    selected,
    onClick,
    child = false,
    parentId = null,
}) => {
    const { icons } = useContext(SearchContext);

    const icon = useMemo(() => {
        const isSelected = selected.includes(id);
        const groupSelected = parentId && selected.includes(parentId);

        return isSelected || groupSelected
            ? icons.checkbox.checked
            : icons.checkbox.unchecked;
    }, [id, selected, icons, parentId]);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();

        onClick(id);
    };

    if (typeof option === 'string') {
        const item = (
            <div className={`item ${child ? '--child' : ''}`} onClick={handleClick}>
                <img src={icon} />

                <p>{option}</p>
            </div>
        );

        return child ? item : (
            <div className="item-container">
                {item}
            </div>
        );
    }

    const props = { selected, onClick };

    return (
        <div className="item-container">
            <PickerItem {...props} id={id} option={option.label} />

            {entries(option.children).map(([key, label]) => (
                <PickerItem
                    {...props}
                    key={key}
                    id={key}
                    option={label}
                    child
                    parentId={id}
                />
            ))}
        </div>
    );
};
